import isCurrentMq from '@module/isCurrentMq';
import getHeaderH from '@module/getHeaderH';
import fixBody from '@module/fixBody';

/**
 * グロナビ開閉
 * 
 * @param {boolean} fullScreen - 全画面表示かどうか
    * trueならヘッダーを覆うように全画面にグロナビを表示（フェードイン）
        *・.js_gnavと.js_menubarのactiveクラスをトグル
    * falseならヘッダーの下にグロナビを表示（アコーディオン）
        *・js_menubarをクリックすると.js_gnavにactiveクラスを追加
        *・js_closeをクリックすると.js_gnavからactiveクラスを削除

 * @param {string|boolean} hideMq - メディアクエリ制御をするかどうか
    * どの画面サイズでもグロナビの開閉を行う場合はfalse
    * 特定の画面サイズでのみグロナビの開閉を行う場合は「その画面サイズ以上のブレイクポイント」を指定

 * @param {number} transition - 開閉時のアニメーション時間（ミリ秒）
*/
const toggleGnav = (fullScreen = false, hideMq = false, transition = 300) => {
    const trigger = document.querySelector('.js_menubar'); //メニューバー
    const target = document.querySelector('.js_gnav'); //グロナビ
    if (!trigger || !target) return;

    /**
     * カスタムプロパティをグロナビに設定
    */
    const setPropertyToTarget = () => {
        // 上からの位置
        const headerH = !fullScreen ? getHeaderH() : 0;
        target.style.setProperty('--top', `${headerH}px`);

        // 展開後の高さ
        if (!fullScreen) {
            const endHeight = `${window.innerHeight - headerH}px`;
            target.style.setProperty('--end-height', endHeight);
        }

        // アニメーション時間
        target.style.setProperty('--transition', `${transition}ms`);
    }

    setPropertyToTarget(); //初期実行
    window.addEventListener('resize', setPropertyToTarget); //リサイズ時実行
    
    /**
     * 開閉
    */
    // 開く
    const open = () => {
        target.classList.add('is_show');
        fixBody('open', transition);
    }

    // 閉じる
    const close = () => {
        target.classList.remove('is_show');
        fixBody('close', transition);
    }

    // トグル
    const toggle = () => {
        trigger.classList.toggle('is_active');
        if (target.classList.contains('is_show')) {
            close();
        } else {
            open();
        }
    }

    // 開閉関数をクリックイベントに登録
    if (fullScreen) {
        const closeTrigger = target.querySelector('.js_close'); //閉じるボタン
        trigger.addEventListener('click', open);
        closeTrigger.addEventListener('click', close);
    } else {
        trigger.addEventListener('click', toggle);
    }

    /**
     * 現在のブレイクポイントがisHideのブレイクポイント以上かどうか
     * @returns {boolean}
     */
    const isHideMq = () => {
        if (!hideMq) return false; //メディアクエリ制御をしない場合はfalseを返す

        const currentMq = isCurrentMq(); //現在のブレイクポイント
        const breakpoints = Object.keys(mq); //ブレイクポイントの配列
        let curentNum = 0;
        let hideNum = 0;

        // 現在のブレイクポイントと指定したブレイクポイントを比較
        for (let i = 0; i < breakpoints.length; i++) {
            const breakpoint = breakpoints[i];
            if (currentMq === breakpoint) {
                curentNum = i;
            }
            if (hideMq === breakpoint) {
                hideNum = i;
            }
        }

        // 現在のブレイクポイントが指定したブレイクポイント以上の場合はtrueを返す
        if (curentNum >= hideNum) return true;
    }

    /**
     * グロナビ内のページ内リンクをクリックしたらグロナビを閉じる
     */
    const anchorLink = () => {
        // グロナビ内のhref="#"のaタグを取得
        const anchorList = target.querySelectorAll('a[href*="#"]');
        if (!anchorList.length) return;

        // クリックイベントを追加
        anchorList.forEach(anchor => {
            anchor.addEventListener('click', () => {
                if (isHideMq()) return; //メディアクエリ制御に該当する場合、処理しない
                close(); //グロナビを閉じる
            });
        });
    }
    anchorLink();

    /**
     * グロナビを開いた状態でリサイズした時isHide以上なら閉じる
    */
    const closeOnMq = () => {
        if (isHideMq()) close();
    }
    window.addEventListener('resize', closeOnMq);
}

export default toggleGnav